import { authStatus } from "./Status";
import axios from "../helper/axios";
export const LoginPage = (userLogin) => {
	return async (dispatch) => {
		dispatch({ type: authStatus.LOGIN_REQUEST });
		const res = await axios.post(`/login/`, userLogin);
		//console.log("res ===== ", res)
		if (res.status === 200) {
			//console.log("Result Data ===== ", res)
			const { token, user } = res.data;
			localStorage.setItem("token", token);
			localStorage.setItem("admin", JSON.stringify(user));
			dispatch({
				type: authStatus.LOGIN_SUCCESS,
				payload: {
					token, user
				}
			})
		} else {
			if (res.status === 201) {
				console.log(res.data);
			}
		}
	}
}
